import React from 'react'

import CareersPage from '../../components/careers/CareersPage'

const Careers = () => {
  return (
    <>

      <CareersPage />


    </>
  )
}

export default Careers